import pageLoading from "./lib/pageLoading.js";
import modalImage from "./lib/modalImage.js";
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import "@/scss/design.scss";

document.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector("body");
  pageLoading();
  modalImage();
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(ScrollToPlugin);
  
  /*----------------   慣性スクロール  ----------------*/

  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  /*----------------   ナビ  ----------------*/

  const header = document.querySelector(".header");
  const navBtn = document.querySelector(".nav_btn");
  const navBack = document.querySelector(".nav_back");

  function navAction() {
    if (header.classList.contains("is_active")) {
      navClose();
    } else {
      navOpen();
    }
  }

  function navOpen() {
    header.classList.add("is_active");
    navBack.classList.add("is_active");
    navBtn.classList.add("is_active");
  }
  function navClose() {
    header.classList.remove("is_active");
    navBack.classList.remove("is_active");
    navBtn.classList.remove("is_active");
  }

  navBtn.addEventListener("click", () => {
    navAction();
  });

  navBack.addEventListener("click", () => {
    navAction();
  });

  /*----------------   タイトル  ----------------*/

  const animeTtl = document.querySelectorAll(".js-ttl_wrapper");
  animeTtl.forEach((elm) => {
    gsap.to(elm, {
      scrollTrigger: {
        trigger: elm,
        start: "top bottom",
        invalidateOnRefresh: true,
        // markers: true,
        onEnter: () => {
          elm.classList.add("is_active");
        },
      },
    });
  });

  /*----------------   画像  ----------------*/

  const animeImg = document.querySelectorAll(".js-img_wrapper");
  animeImg.forEach((elm) => {
    gsap.to(elm, {
      scrollTrigger: {
        trigger: elm,
        start: "top 95%",
        invalidateOnRefresh: true,
        // markers: true,
        onEnter: () => {
          elm.classList.add("is_active");
        },
      },
    });
  });

  /*----------------   パララックス  ----------------*/

  const parallax = document.querySelectorAll(".parallax_element");
  if(parallax){
    parallax.forEach((elm) => {
      let parallaxY = parseFloat(elm.dataset.parallax);
      if (document.documentElement.clientWidth < 768) {
        parallaxY /= 3;
      }
      gsap.set(elm, {
        y: parallaxY,
      });
      gsap.to(elm, {
        y: -parallaxY,
        scrollTrigger: {
          trigger: elm,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          // markers: true,
        },
      });
    });
  };


  /*----------------   swiper index  ----------------*/

  if (body.classList.contains("index")) {

    // MV

    const mvSwiper = new Swiper(".mv_swiper", {
      loop: true,
      effect: "fade",
      speed: 2000,
      // speed: 20000000000,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });


    // 施工事例

    const worksSwiper = new Swiper(".index-works_swiper", {
      slidesPerView: 1,
      spaceBetween: 15,
      freeMode: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 50
        },
      },
      navigation: {
        nextEl: ".index-works_swiper-button-next",
        prevEl: ".index-works_swiper-button-prev",
      },
    });
  }

  /*----------------   swiper single  ----------------*/

  if (body.classList.contains("single")) {
    const thumb = document.querySelectorAll(".single_thumb_img");

    const switchThumb = (index) => {
      document
        .querySelectorAll(".single_thumb_img.thumb_active")
        .forEach((el) => {
          el.classList.remove("thumb_active");
        });
      thumb[index].classList.add("thumb_active");
    };

    const singleSwiper = new Swiper(".single_swiper_main", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 500,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        afterInit: (swiper) => {
          thumb[swiper.realIndex].classList.add("thumb_active");
          for (let i = 0; i < thumb.length; i++) {
            thumb[i].onclick = () => {
              swiper.slideTo(i);
            };
          }
        },
        slideChange: (swiper) => {
          switchThumb(swiper.realIndex);
        },
      },
    });
  }

  /*----------------   お問い合わせ  ----------------*/

  if (body.classList.contains("contact")) {
    topValidation();
  }


});
